module.exports = __webpack_public_path__ + "img/completion_right.5e8d7910.jpg";